export default __webpack_public_path__ + "46fc4501d13ba70b346a8248e77cdb2e.svg";